//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniPopup from "@/components/uni-popup/uni-popup.vue"
export default {
  data() {
    return {
      t: '',
      showCode: false,
      orderId: ''
    }
  },
  components: {
    uniPopup
  },
  async onLoad(event) {
    this.showCode = parseInt(event.hasCode || 0) === 1
    this.orderId = event.orderId || ''
    await this.queryPrice()
  },
  methods: {
    async queryPrice () {
      let giveCouponOrder = window.sessionStorage.getItem('giveCouponOrder')
      if (this.orderId !== giveCouponOrder) {
        let data = await this.$ajax({
          method: 'post',
          url: '/weChat/pay/giveCoupon',
          data: {
            orderCode: this.orderId
          }
        })
        if (data.data) {
          this.showCode = true
          sessionStorage.setItem('giveCouponOrder', this.orderId)
        }
      }
    },
    handleClick(path,status) {
      if(status==='index'){
		  uni.switchTab({
		    url: path
		  })
	  } else {
		  uni.redirectTo({
		  	url:path
		  })
	  }
    },
    jump() {
      uni.redirectTo({
        url: '/pages/index/index'
      })
    }
  }
}
